// import { useMutation } from "@tanstack/react-query";
// import { loginUser } from "../api/authService";

// export function useLogin() {
//   return useMutation({
//     mutationFn: loginUser,
//   });
// }
import { useMutation } from "@tanstack/react-query";

export function useLogin() {
  return useMutation({
    mutationFn: async ({ email, password }: { email: string; password: string }) => {
      // -------------------------------
      //   🧪 Dummy Logic (Fake Login)
      // -------------------------------
         console.log("Login attempt:", { email, password });
      // Option 1: Accept any email/password
      // (useful for testing UI & navigation)
      await new Promise((r) => setTimeout(r, 1000)); // simulate API delay

      // Option 2: Hardcode one valid login
    //   if (email !== "admin@test.com" || password !== "123456") {
    //     throw new Error("Invalid credentials");
    //   }

      // return a fake token
      return {
        token: "dummy-jwt-token-123",
        user: {
          name: "Admin User",
          email,
        },
      };
    },
  });
}
